import React from 'react';
import {
  string, object, array, oneOfType, func,
} from 'prop-types';
import some from 'lodash/some';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';
import { interpolate } from '../../../shared/utils/commonUtils';

const getMessage = ({
  id, values, defaultMessage, i18n,
}) => {
  return defaultMessage && i18n(id, values) === id ? i18n(defaultMessage, values) : i18n(id, values);
};
const I18nMessage = ({
  id, values, i18n, defaultMessage,
}) => {
  if (!id) {
    return null;
  }
  if (!some(values, value => typeof value !== 'string')) {
    const messageData = getMessage({
      id, values, defaultMessage, i18n,
    });
    return <span>{messageData}</span>;
  }

  const message = getMessage({
    id, values: {}, defaultMessage, i18n,
  });
  const result = interpolate(message, values); // dom value
  return typeof result === 'string' ? <span>{result}</span> : result;
};

I18nMessage.propTypes = {
  id: string.isRequired,
  values: oneOfType([ object, array ]),
  i18n: func.isRequired,
  defaultMessage: string,
};

export default withI18n(I18nMessage);
